import type { Project } from '~/common/types';

export function formatAddress(address: Project['address2']): string {
  if (!address) return '—';
  const street = address.street ?? '';
  const city = address.city ?? '';
  const state = address.state ?? '';
  const zipCode = address.zipCode ?? '';
  const line = [street, city, `${state} ${zipCode}`.trim()].filter(Boolean).join(', ');
  return line || '—';
}
